// extracted by mini-css-extract-plugin
export default {"mTop4":"styles_mTop4__aEG6H"};